import { _t } from "../../services/TranslationService.js";

export function generateView(mybetsprofile) {
let username = localStorage.getItem("username");

let role = localStorage.getItem("role");
 const uniqueDates = [
     ...new Set(mybetsprofile.map((item) => item.created_at.split(' ')[0]))
 ].sort().reverse();

 let myBetsView = '';

 uniqueDates.forEach((date) => {
    let singleDateView = "";

     mybetsprofile
        .filter((a) => a.created_at.split(' ')[0] === date)
        .map((mybet) => {
            // console.log(`mybet qekyyy`,mybet)
            let winLabel = '';
            let winLabelText = '';
            let cashOutButton = false;
            let cashingOut = false;

            if(!mybet.possible_win){
                winLabel = '<span></span>';
            }
            if(!mybet.possible_win && (mybet.name === 'Won')){
                winLabel = `<span class="wonCoefItem">${mybet.currency_name}  `+parseFloat(mybet.win).toFixed(2)+`</span>`;
            }
            if(mybet.possible_win && (mybet.name === 'Won')){
                winLabel = `<span class="wonCoefItem">${mybet.currency_name}  `+parseFloat(mybet.possible_win).toFixed(2)+'</span>'
            }
            if(mybet.possible_win && (mybet.name === 'Lost')){
                winLabel = `<span>${mybet.currency_name}  `+parseFloat(mybet.stake).toFixed(2)+'</span>'
            }
            if(!mybet.possible_win && (mybet.name === 'Lost')){
                winLabel = `<span>${mybet.currency_name}  `+parseFloat(mybet.stake).toFixed(2)+'</span>'
            }
            if (!mybet.possible_win && (mybet.name === 'Approved')) {
              winLabel = `<span>${mybet.currency_name}  ` + parseFloat(mybet.stake).toFixed(2) + '</span>'+ `<a class="repeatTicket" bet-id="${mybet.id}">${_t('Perserit')}</a>`
            }
            if (mybet.possible_win && (mybet.name === 'Approved')) {
              winLabel = `<span>${mybet.currency_name}  ` + parseFloat(mybet.stake).toFixed(2) + '</span>' + `<a class="repeatTicket" bet-id="${mybet.id}">${_t('Perserit')}</a>`
            }

            if( mybet.name === 'Approved' ){
              cashOutButton = true;
            }

            if(mybet.cash_out == 1){
              cashingOut = true;
            }

            if(mybet.possible_win && (mybet.name === 'Approved') && (mybet.number_of_live_matches == 0) && role == 'User'){
                winLabel = `<a class="cancelBetBtn">Anulo</a> `+ `<a class="repeatTicket" bet-id="${mybet.id}">${_t('Perserit')}</a>`
            }
            if(!mybet.possible_win && (mybet.name === 'Approved') && (mybet.number_of_live_matches == 0) && role == 'User'){
                winLabel = `<a class="cancelBetBtn">Anulo</a> `+ `<a class="repeatTicket" bet-id="${mybet.id}">${_t('Perserit')}</a>`
            }
            if(mybet.name === 'Won'){
                winLabelText = `<span class="greenColour">${_t('Fituese')}</span>`;
            }
            if(mybet.name === 'Lost'){
                winLabelText = `<span class="redColour">${_t('Humbese')}</span>`;
            }
            if(mybet.name === 'Approved'){
                winLabelText = '<span></span>';
            }
            if(mybet.name === 'Canceled'){
                winLabelText = `<span>${_t('E anuluar')}</span>`;
            }

            let bonusPercentage = (parseFloat(mybet.bonus_value) / parseFloat(mybet.win ? mybet.win.split('/')[0] : 0) * 100).toFixed(0);
            let bonusValue = parseFloat(mybet.bonus_value).toFixed(2);
            let cashOutValue = parseFloat(mybet.cash_out_value).toFixed(2);

            let bonusView = '';

            if(bonusValue > 0 || bonusPercentage > 0){
                bonusView = `<div class="singleBetBonus">
                <span>${_t('Bonus')}</span>
                <span>${bonusValue} (${bonusPercentage})%</span>
              </div>`
            }
            singleDateView += `<div class="singleBetTable" data-value="${mybet.stake}" cash-out-value="${cashOutValue}" cashingOut="${cashingOut}" cash-out-status="${cashOutButton}">
            <a class="singleBetHeader" bet-id="${mybet.id}" bet-can-cash="${mybet.can_cash}">
              <div class="singleBetHeaderLeft">
                <span>${mybet.username}</span>
                <span>${mybet.bet_number} - ${mybet.created_at.split(' ')[1]}</span>
              </div>
              <div class="singleBetHeaderRight">
                ${winLabel}
                ${winLabelText}
              </div>
            </a>
            <div class="singleBetContent">

            </div>
            <div class="singleBetFooter">
              <div class="singleBetAmount">
                <span>${_t('Amount')}</span>
                <span>${mybet.currency_name} ${parseFloat(mybet.stake).toFixed(2)} <i></i></span>
              </div>
              ${bonusView}
              <div class="singleBetToReturn">
                <span>${_t('To Return')}</span>
                <span>${ mybet.win && mybet.win.includes('/') ? `${parseFloat(mybet.win.split('/')[0]).toFixed(2)} / ${parseFloat(mybet.win.split('/')[1]).toFixed(2)}` : parseFloat(mybet.win).toFixed(2)} <i></i></span>
              </div>
            </div>
          </div>`;
        });

    if( singleDateView == "") {
        return;
    }else {
        console.log(date);
        myBetsView =
            myBetsView +
            ` <div class="myBetGroupWrapper">
                        <div class="myBetGroupLabel">
                           <span>${date.split('-')[2]}/${date.split('-')[1]}/${date.split('-')[0]}</span>
                        </div>
                        <div class="myBetGroupContent">
                          ${singleDateView}
                        </div>
                    </div>`;
    }
 });


 return myBetsView;
}
